import React from "react";

function PowerBI() {
  return (
    <div className="flex flex-col items-center justify-center w-full px-4">
      <h2 className="text-2xl font-semibold mb-4 text-center">
        Value &amp; Product Trends of the Groups Before the Bot/Platform is
        Started
      </h2>

      {/* make this container taller */}
      <div className="w-full max-w-6xl h-[700px]">
        <iframe
          title="To be Screenshot"
          className="w-full h-full rounded shadow-lg"
          src="https://app.powerbi.com/view?r=eyJrIjoiZWUyZmYwYTAtODUyNS00ZGNlLWE3YjctYTJmZDI0N2FmNzc1IiwidCI6IjM4MzJjYjE4LTU4NjMtNDZlNi1hNzhlLTFhMThjYzkxNzIyYiJ9"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
}

export default PowerBI;
